import type { SidebarNavItem } from '@p31ca/design-core/compositions'

/** forge nav — DATA (rule 0: chrome is data, not markup). The single source
 *  for the sidebar rail, the mobile bottom nav, and the chrome config. */
export const NAV_ITEMS: SidebarNavItem[] = [
  { path: '/', label: 'Home', emoji: '🏠', flagship: true },
  { path: '/playground', label: 'Playground', emoji: '🛝' },
  { path: '/catalog', label: 'Catalog', emoji: '🧩', flagship: true },
  { path: '/identity', label: 'Identity', emoji: '🔐', flagship: true },
  { path: '/compose', label: 'Compose', emoji: '⚛️', flagship: true },
  { path: '/activity', label: 'Activity', emoji: '📈' },
  { path: '/channels', label: 'Channels', emoji: '📤' },
]